import React from 'react';
import { usePrivacy } from '../../contexts/PrivacyContext';
import { Shield, ShieldAlert } from 'lucide-react';

export const PrivacyToggle: React.FC = () => {
  const { isPrivacyMode, togglePrivacyMode } = usePrivacy();

  return (
    <button
      onClick={togglePrivacyMode}
      title="Toggle Office Privacy Mode (Alt+P)"
      className={`flex items-center gap-2 px-2.5 py-1.5 rounded-lg text-xs font-medium border transition-colors ${
        isPrivacyMode
          ? 'bg-indigo-50/80 border-indigo-200 text-indigo-700 shadow-sm'
          : 'bg-white border-slate-200 text-slate-600 hover:bg-slate-50'
      }`}
    >
      {isPrivacyMode ? (
        <ShieldAlert className="w-3.5 h-3.5 text-indigo-600" />
      ) : (
        <Shield className="w-3.5 h-3.5 text-slate-400" />
      )}
      <span>{isPrivacyMode ? 'Privacy Active' : 'Privacy Mode'}</span>
      <kbd className="hidden sm:inline-block px-1.5 py-0.5 text-[10px] bg-slate-100 border border-slate-200 rounded text-slate-500">
        Alt+P
      </kbd>
    </button>
  );
};
